export default "__VITE_ASSET__7tvWn6ty__"